export default __webpack_public_path__ + "static/media/ECU.85723273.svg";